(() => {
  const body = document.body;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inEditor = Boolean(window.Shopify && Shopify.designMode);
  const loader = document.querySelector('.rt-loader');
  const count = document.querySelector('.rt-loader__count');
  const track = document.querySelector('.rt-loader__track span');

  const finishLoading = () => {
    if (track) track.style.width = '100%';
    if (count) count.textContent = '100';
    window.setTimeout(() => {
      body.classList.remove('rt-loading');
      body.classList.add('rt-loaded');
      window.setTimeout(() => loader && loader.remove(), 700);
    }, reduceMotion || inEditor ? 0 : 240);
  };

  if (reduceMotion || inEditor) {
    finishLoading();
  } else {
    let progress = 0;
    const timer = window.setInterval(() => {
      progress = Math.min(92, progress + Math.ceil(Math.random() * 9));
      if (count) count.textContent = String(progress).padStart(2, '0');
      if (track) track.style.width = `${progress}%`;
    }, 75);
    const complete = () => {
      window.clearInterval(timer);
      finishLoading();
    };
    if (document.readyState === 'complete') complete();
    else window.addEventListener('load', complete, { once: true });
    window.setTimeout(complete, 2200);
  }

  const revealTargets = document.querySelectorAll('.compact-products, .campaign-banner__content, .tiles-heading, .collection-tile, .split-editorial a, .footer-top, .footer-ghost, .page-section, .main-product');
  revealTargets.forEach((element) => element.classList.add('rt-reveal'));
  const mediaTargets = document.querySelectorAll('.hero, .campaign-banner');
  mediaTargets.forEach((element) => element.classList.add('rt-media-reveal'));

  if (reduceMotion || !('IntersectionObserver' in window)) {
    document.querySelectorAll('.rt-reveal, .rt-media-reveal').forEach((element) => element.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    document.querySelectorAll('.rt-reveal, .rt-media-reveal').forEach((element) => observer.observe(element));
  }

  const header = document.querySelector('.site-header');
  if (header) {
    let lastY = window.scrollY;
    let ticking = false;
    const updateHeader = () => {
      const currentY = window.scrollY;
      header.classList.toggle('header--scrolled', currentY > 40);
      header.classList.toggle('header--hidden', currentY > 160 && currentY > lastY + 3);
      if (currentY < lastY) header.classList.remove('header--hidden');
      lastY = currentY;
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
    updateHeader();
  }
})();
